import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';
import { Observable } from 'rxjs';
import { ConfirmationService } from 'primeng/primeng';
import { CustomerClusterService } from './../../../services/customer/customer-cluster.service';
import { Cluster, CustomerCluster } from './../../../models/loyalty-cluster.model';
import { LoyaltyClusterService } from './../../../services/loyalty/loyalty-cluster.service';
import { Component, OnInit } from '@angular/core';
import { CardBatch } from '../../../models/loyalty-card-batch.model';
import { Channel } from '../../../models/loyalty-channel.model';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCardBatchService } from '../../../services/loyalty/loyalty-card-batch.service';
import { Router } from '@angular/router';
import { LoyaltyChannelService } from '../../../services/loyalty/loyalty-channel.service';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-loyalty-card-batch',
  templateUrl: './loyalty-card-batch.component.html',
  styleUrls: ['./loyalty-card-batch.component.css']
})
export class LoyaltyCardBatchComponent implements OnInit {

  listChannel = new Array<{ value: string, label: string }>();
  /*listCluster = new Array<{ value: string, label: string }>();*/
  listDeploy = new Array<{ value: string, label: string }>();
  channels = new Map<string, Channel>();
  clusters = new Map<string, Cluster>();
  clusterHeads = new Map<string, CustomerCluster>();
  serverPagination = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;
  newDataAvailable = false;
  translations = {};
  render = {
    datatable: false
  }
  model = {
    filterCusterHead: ""
  }
  listStates: Array<{value: string, label: string}>;

  // Mostra tasti di edit, delete e recover
  cardDefPermissions: Permission

  constructor(
    private translate: TranslateService,
    public cardBatchService: LoyaltyCardBatchService,
    private srvPermission: PermsService,
    private router: Router,
    private channelService: LoyaltyChannelService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {

    const TRANSLATIONS = this.translate.get([
      'card_batch.anag',
      'card_batch.creating',
      'card_batch.deploying',
      'card_batch.deployed',
      'card_batch.ext_wait',
      'card_batch.ext_fail',
      'card_batch.confirm_delete_title',
      'card_batch.confirm_deploy_title',
      'card_batch.confirm_delete_message',
      'card_batch.confirm_deploy_message',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'card_def'});

    const CHANNELS =   this.channelService.list();

    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS,
      CHANNELS

    ).subscribe(([t, resPermissions, resChannels]) => {

      this.listDeploy.push(
        { value: null, label: '' },
        { value: '0', label: t['card_batch.anag'] },
        { value: '1', label: t['card_batch.creating'] },
        { value: '2', label: t['card_batch.deploying'] },
        { value: '3', label: t['card_batch.deployed'] },
        { value: '4', label: t['card_batch.ext_wait'] },
        { value: '9', label: t['card_batch.ext_fail'] }
      );

      this.translations['confirm_delete_title'] = t['card_batch.confirm_delete_title'];
      this.translations['confirm_deploy_title'] = t['card_batch.confirm_deploy_title'];
      this.translations['confirm_delete_message'] = t['card_batch.confirm_delete_message'];
      this.translations['confirm_deploy_message'] = t['card_batch.confirm_deploy_message'];

      this.cardDefPermissions = resPermissions;

      this.listStates = [];
      this.listStates.push({ label: '', value: null });
      this.listStates.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: t['common.status_onlyDeleted'], value: '1' });

      this.listChannel = [];
      this.listChannel.push({ label: '', value: null });

      for (const channel of resChannels.data) {
        this.channels.set(channel.id, channel);
        this.listChannel.push({
          value: channel.id.toString(),
          label: channel.channelDescription
        });
      }

      this.render.datatable = true;

  });




   //this.reloadList(true);
  }
/*
  reloadList(init = false) {
    this.newDataAvailable = false;
    if (!init) {
      this.cardBatchService.list().subscribe( () => {
        this.newDataAvailable = true;
      });
    }
  }
*/
  readyDeployBatch(id) {

    this.confirmationService.confirm({
      header: this.translations['confirm_deploy_title'],
      message: this.translations['confirm_deploy_message'],
      accept: () => {

        this.cardBatchService.readyDeploy(id).subscribe(() => {
          this.newDataAvailable = true;
          //this.reloadList();
        });

      }
    });


  }

  resetDeployBatch(id) {
    this.cardBatchService.resetDeploy(id).subscribe(() => {
      this.newDataAvailable = true;
      //this.reloadList();
    });
  }

  edit(cardBatch: CardBatch) {
    this.router.navigate(['/loyalty/card_batch/form', cardBatch.id]);
  }

  add() {
    this.router.navigate(['/loyalty/card_batch/form']);
  }

  remove(cardBatch) {
    this.confirmationService.confirm({
      header: this.translations['confirm_delete_title'],
      message: this.translations['confirm_delete_message'],
      accept: () => {

        this.cardBatchService.remove(cardBatch.id).subscribe(() => {
          this.newDataAvailable = true;
          //this.reloadList();
        });

      }
    });
  }
  recover(cardBatch){
    this.cardBatchService.recover(cardBatch).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-batch/loyalty-card-batch.component.ts